// extracted by mini-css-extract-plugin
export default {"container":"CustomSelectDropdown__container___vzfpZ","middleContainer":"CustomSelectDropdown__middleContainer___Qqdq7"};